import { useCallback, useContext, type FunctionComponent } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/legacy-i18n';
import { asMoney } from '@trello/legacy-i18n/formatters';
import { Button } from '@trello/nachos/button';

import { PlanComparisonContext } from '../PlanComparisonContext';

import styles from './FreePlanCard.less';

const format = forTemplate('billing_page_one');

interface FreePlanCardProps {
  isInPPCohort?: boolean;
}

export const FreePlanCard: FunctionComponent<FreePlanCardProps> = ({
  isInPPCohort,
}) => {
  const { variation, onChooseFree } = useContext(PlanComparisonContext);

  const onChooseFreeWithAnalytics = useCallback(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'chooseFreeButton',
      source: 'trelloPlanPricingModal',
      attributes: {
        viaEndOfTrial: true,
      },
    });
    onChooseFree?.();
  }, [onChooseFree]);

  if (variation !== 'end-of-trial-friction-overlay') {
    return null;
  }

  return (
    <section className={styles.planCard}>
      <article>
        <h3 className={styles.name}>{format('free-name')}</h3>
        <p className={styles.info}>
          {isInPPCohort
            ? format('free-description-personal-productivity')
            : format('free-description-repackaging-gtm')}
        </p>
        <div className={styles.priceContainer}>
          <span className={styles.price}>
            {format('amount-usd', {
              amount: asMoney(0).replace(/\.00$/, ''),
            })}
          </span>
          <span className={styles.frequency}>
            {format('per-user')}
            <br />
            {format('per-month')}
          </span>
        </div>
        <div className={styles.ctaContainer}>
          <Button onClick={onChooseFreeWithAnalytics}>
            {format('choose-free')}
          </Button>
        </div>
      </article>
    </section>
  );
};
